// Import Actions
import { SET_ORDERS } from './OrderActions';
import { SET_IS_FETCHING } from '../App/AppActions';
import { LOGOUT_USER } from '../User/UserActions';

// Initial State
export const initialState = {
    data: [],
    isFetching: false,
};

const OrderReducer = (state = initialState, action) => {
    switch(action.type) {
        case SET_ORDERS: {
            const otherOrders = state.data.filter(order => !action.orders.find(orderToSet => orderToSet._id === order._id));
            return {
                ...state,
                data: otherOrders.concat(action.orders),
                isFetching: false,
            };
        }

        case SET_IS_FETCHING:
            if(action.dataType === 'orders') {
                return {
                    ...state,
                    isFetching: action.isFetching,
                };
            }
            return state;

        case LOGOUT_USER:
            return initialState;

        default:
            return state;
    }
};

export default OrderReducer;
